import React from "react";
import { Chip, Grid } from "@mui/material";
import { Article, FolderOutlined, VisibilityOffOutlined, VisibilityOutlined } from "@mui/icons-material";
import { MediaObject } from "../../types/MediaObject";

type MediaObjectChipsProps = {
  mediaObject: MediaObject;
  showFolder: boolean;
};

export default function MediaObjectChips({ mediaObject, showFolder = true }: MediaObjectChipsProps) {
  return (
    <Grid container spacing={1}>
      {showFolder && (
        <Grid>
          <Chip
            label={mediaObject.electronicFileFolderPath}
            icon={<FolderOutlined />}
            size={"small"}
            variant={"outlined"}
          />
        </Grid>
      )}
      {mediaObject.showInExternalView && (
        <Grid>
          <Chip label={"Für Extern sichtbar"} icon={<VisibilityOutlined />} size={"small"} variant={"outlined"} />
        </Grid>
      )}
      {mediaObject.showInGallery && (
        <Grid>
          <Chip
            label={"Für Mandantschaft sichtbar"}
            icon={<VisibilityOutlined />}
            size={"small"}
            variant={"outlined"}
          />
        </Grid>
      )}
      {!mediaObject.showInExternalView && !mediaObject.showInGallery && (
        <Grid>
          <Chip label={"Nur intern sichtbar"} icon={<VisibilityOffOutlined />} size={"small"} variant={"outlined"} />
        </Grid>
      )}
      {mediaObject.fieldname === "extrajudicialLetter" && (
        <Grid>
          <Chip label={"AGS"} icon={<Article />} size={"small"} variant={"outlined"} />
        </Grid>
      )}
    </Grid>
  );
}

